// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.host-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 8px;
  font-size: 13px;
}
.host-row select {
  flex: 1;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: inherit;
  font: inherit;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  padding: 8px 0;
  font-family: monospace;
  font-size: 13px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 8px;
}
.breadcrumbs .crumb {
  padding: 2px 4px;
  border-radius: 3px;
}
.breadcrumbs .crumb.active, .breadcrumbs .crumb.root {
  cursor: pointer;
}
.breadcrumbs .crumb.active:hover, .breadcrumbs .crumb.root:hover {
  background: rgba(255, 255, 255, 0.1);
}
.breadcrumbs .separator {
  opacity: 0.4;
}

.folder-list {
  max-height: 360px;
  overflow-y: auto;
}

.folder-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
}
.folder-item:hover {
  background: rgba(255, 255, 255, 0.08);
}
.folder-item.parent {
  opacity: 0.7;
}
.folder-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  opacity: 0.6;
}

.empty {
  padding: 24px;
  text-align: center;
  opacity: 0.5;
  font-size: 13px;
}

.loading {
  display: flex;
  justify-content: center;
  padding: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/folder-picker-dialog/folder-picker-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;AAAF;AAEE;EACE,gBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AACM;EACE,oCAAA;AACR;AAIE;EACE,YAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAHF;AAKE;EACE,qCAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AALJ;;AASA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AANF","sourcesContent":[".host-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0 8px;\n  font-size: 13px;\n\n  select {\n    flex: 1;\n    padding: 4px 6px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    background: transparent;\n    color: inherit;\n    font: inherit;\n  }\n}\n\n.breadcrumbs {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2px;\n  padding: 8px 0;\n  font-family: monospace;\n  font-size: 13px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 8px;\n\n  .crumb {\n    padding: 2px 4px;\n    border-radius: 3px;\n\n    &.active, &.root {\n      cursor: pointer;\n      &:hover {\n        background: rgba(255, 255, 255, 0.1);\n      }\n    }\n  }\n\n  .separator {\n    opacity: 0.4;\n  }\n}\n\n.folder-list {\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.folder-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  &.parent {\n    opacity: 0.7;\n  }\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    opacity: 0.6;\n  }\n}\n\n.empty {\n  padding: 24px;\n  text-align: center;\n  opacity: 0.5;\n  font-size: 13px;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  padding: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
